<template>
    <div class="qksm qksm7">
        <div class="nogap">
            <p><b>（二）一般公共预算安排的“三公”经费情况</b></p>
            <p>
                2021年，通过一般公共预算财政拨款安排的“三公”经费预算共{{isMoney(T11.总计)}}万元，其中：
                <template v-for="(item, idx) in T11.项目">
                    {{item.name}}{{isMoney(item.value)}}万元{{idx==T11.项目.length-1?'。':'，'}}
                </template>
            </p>
            <p>
                2021年“三公”经费预算
                <span class="hide_pdf">
                    （去年预算数<reason type="money" classname="qksm money editLast" name="三公总计" v-model:value="qksm['三公总计']"></reason>万元）
                </span>
                比2020年{{growthValueText(T11.总计,qksm['三公总计'])}}万元，其中：
                <template v-for="(item, idx) in T11.项目" :key="idx">
                    {{item.name}}
                    <span class="hide_pdf">
                        （去年预算数<reason type="money" classname="qksm money editLast" :name="'三公'+item.name" v-model:value="qksm['三公'+item.name]"></reason>万元）
                    </span>
                    <span v-if="num(item.value).toFixed(2)==num(qksm['三公'+item.name]).toFixed(2)">
                        与2020年基本持平
                    </span>
                    <span v-else>
                        {{growthValueText(item.value,qksm['三公'+item.name])}}万元
                    </span>
                    {{idx<T11.项目.length-1 ? '、' : '。'}}
                </template>
                <template v-for="(item, idx) in T11.项目" :key="idx" >
                    <template v-if="num(item.value).toFixed(2) != num(qksm['三公'+item.name]).toFixed(2)">
                    {{item.name}}{{num(item.value) > num(qksm['三公'+item.name]) ? '增加' : '减少'}}的主要原因是
                    <reason type="textarea" classname="qksm widest because" :name="'三公原因'+item.name" v-model:value="qksm['三公原因'+item.name]"></reason>
                    </template>
                </template>
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm7",
        props: {
            T11: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
            }
        },
    };
</script>